// 텍스트 컴포넌트

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역
import React, { // 리액트 베이스
  useEffect, // 상태 변경 이벤트 헨들러
  useState, // 내부 상태 관리 훅
  useRef, // 객체 참조자
  forwardRef,
  Fragment, // 재사용 가능한 라이브러리 컴포넌트에서, 자식 중 하나에 ref를 전달
  useCallback, // 상태 변경시까지 함수 재사용 장치 // 재사용 가능한 라이브러리 컴포넌트에서, 자식 중 하나에 ref를 전달
} from 'react';
import M from 'src/com/keymansco/chihuahuaone/helper/mainHelper'; // 메인 헬퍼
import atom from 'src/com/keymansco/chihuahuaone/atom/index'; // 원자 컴포넌트
import molecule from 'src/com/keymansco/chihuahuaone/molecule/index'; // 분자 컴포넌트
import organism from 'src/com/keymansco/chihuahuaone/organism/index'; // 업무 컴포넌트
import template from 'src/com/keymansco/chihuahuaone/template/index'; // 템플릿 컴포넌트
import page from 'src/com/keymansco/chihuahuaone/page/index'; // 페이지 컴포넌트

// 동적 영역
import TextModel from './TextModel'; // 모델
import {
  Text as TextOfNativeBase, // 텍스트
} from 'native-base';

// =================================================================================================
// 상수
// =================================================================================================

// =================================================================================================
// 컴포넌트 정의
// =================================================================================================
const Text = forwardRef((props, ref) => {
  // 내부 상태 [컴포넌트 자체 뷰 갱신 전용. private.]
  // const [number, setNumber] = useState(0);

  // 외부 상태 [외부 개방용. public.]
  let P = TextModel; // P 자동완성용
  P = props; // 속성. 읽기전용.

  // 참조 변수
  // const domRef = useRef(null);

  // 상수

  // =================================================================================================
  // 컨테이너 컴포넌트 이벤트 핸들러
  // =================================================================================================
  // 컴포넌트 미운트 시 [componentDidMount, componentDidUpdate] [인자값 변경시 동작] [빈 배열 적용시 최초 마운트 때 한번 동작]
  useEffect(() => {
    // M.log.info('Text');

    // 컴포넌트 언마운트 시(componentWillUnmount)
    return () => {};
  }, []);

  // =================================================================================================
  // 컴포넌트 함수 정의
  // =================================================================================================

  // =================================================================================================
  // 그리기
  // =================================================================================================
  // 렌더링(render)
  return (
    <TextOfNativeBase // 텍스트
      // {...(P.type == 'basic' ? M.style.layout.alignSelfCenter : {})} // align-self
      {...(P.type == 'basic' ? M.style.font.label : P.type == 'title' ? M.style.font.title : P.type == 'big' ? M.style.font.big : {})}
      margin={P.type == 'basic' ? M.theme.space[0.5] : P.type == 'title' ? M.theme.space[2] : undefined} // margin [m]
      numberOfLines={P.isSingleLine ? 1 : undefined}
      ellipsizeMode={P.isSingleLine ? 'clip' : undefined}
      {...P}
      ref={ref}
      style={{
        // 인라인 스타일 [스타일 분리시, 모양새 추정에 불리.]
        ...P.style,
      }}
    >
      {P.children}
    </TextOfNativeBase>
  );
});

// =================================================================================================
// 내보내기
// =================================================================================================
export default Text;
